import { observer } from "mobx-react-lite";

import { PlaygroundDialogType } from "./constants";
import { NoInputVariables } from "./DialogTypes/NoInputVariables";
import { PromptToSaveVersion } from "./DialogTypes/PromptToSaveVersion";
import { usePlaygroundDialogStore } from "./playground-dialog-store";

export const PlaygroundDialog = observer(
  ({ handleButtonClick }: { handleButtonClick: () => void }) => {
    const store = usePlaygroundDialogStore();

    switch (store.dialogType) {
      case PlaygroundDialogType.NoInputVariables:
        return <NoInputVariables />;
      case PlaygroundDialogType.PromptToSaveVersion:
        return <PromptToSaveVersion handleButtonClick={handleButtonClick} />;
      default:
        return null;
    }
  },
);
